webpackJsonp([70144966829960],{

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _callToAction = __webpack_require__(40);
	
	var _callToAction2 = _interopRequireDefault(_callToAction);
	
	var _seo = __webpack_require__(9);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "first-section" },
	      _react2.default.createElement(_seo2.default, {
	        isDynamic: false,
	        title: "Gojek: Contact Us",
	        description: "Feel free to contact us for any queries regarding job openings or any other queries.",
	        url: "https://gojek.io"
	      }),
	      _react2.default.createElement(
	        "section",
	        { className: "first-section" },
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid" },
	          _react2.default.createElement(
	            "div",
	            { className: "row align-items-center bg-green" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-5 p-md-0 p-5" },
	              _react2.default.createElement(
	                "h1",
	                { className: "maison-bold text-center text-white" },
	                "Contact Us"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-7 p-0" },
	              _react2.default.createElement("div", { className: "bg-dark contact-banner go-jek-work-gradient background-img relative-position" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "section",
	          { className: "my-md-5 py-md-0 py-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4" },
	              _react2.default.createElement(
	                "p",
	                { className: "font-md text-green    maison-bold place pb-1" },
	                "Gojek Head Office (Jakarta):"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "roboto-regular address text-black" },
	                "Pasaraya Blok M Gedung B Lt. 6,",
	                _react2.default.createElement("br", null),
	                "Jalan Iskandarsyah II ",
	                _react2.default.createElement("br", null),
	                " No.7, RW. 2, Melawai, Kebayoran Baru,",
	                _react2.default.createElement("br", null),
	                " RT.3/RW.1, Melawai, Kby. Baru, ",
	                _react2.default.createElement("br", null),
	                "Kota Jakarta Selatan,",
	                _react2.default.createElement("br", null),
	                " Daerah Khusus Ibukota ",
	                _react2.default.createElement("br", null),
	                "Jakarta 12160"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4" },
	              _react2.default.createElement(
	                "p",
	                { className: "font-md text-green mb-0  maison-bold place pb-4" },
	                "Gojek Singapore:"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "roboto-regular address text-black" },
	                "8 Shenton Way,",
	                _react2.default.createElement("br", null),
	                " AXA Tower, ",
	                _react2.default.createElement("br", null),
	                "Singapore 068811"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4" },
	              _react2.default.createElement(
	                "p",
	                { className: "font-md text-green mb-0  maison-bold place pb-4" },
	                "Gojek India:"
	              ),
	              _react2.default.createElement(
	                "b",
	                { className: "text-black" },
	                "Bengaluru:"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "roboto-regular address text-black" },
	                "2nd, 4th & 6th Floor, Tower B,",
	                _react2.default.createElement("br", null),
	                "Diamond District, HAL Old Airport Road,",
	                _react2.default.createElement("br", null),
	                " Bengaluru, ",
	                _react2.default.createElement("br", null),
	                "Karnataka 560008"
	              ),
	              _react2.default.createElement(
	                "b",
	                { className: "text-black" },
	                "Gurgaon:"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "roboto-regular address text-black" },
	                "1st Floor, Tower A, Building 8A,",
	                _react2.default.createElement("br", null),
	                "DLF Cyber Hub, DLF Cyber City,",
	                _react2.default.createElement("br", null),
	                "DLF Phase 3,",
	                _react2.default.createElement("br", null),
	                "Gurgaon 122002"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "section",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "row " },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-5 bg-green" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "h5 text-uppercase maison-extrabold text-white text-center pt-5 pb-4 contact" },
	                  "Careers"
	                ),
	                _react2.default.createElement(_callToAction2.default, {
	                  theme: "green",
	                  text: "Think you fit the bill?",
	                  btnText: "APPLY NOW",
	                  link: "/careers/"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-7 gray-bg text-black text-center" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "maison-extrabold text-uppercase h5 pt-5 pb-4" },
	                  "Gojek tech contact"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "pt-4 text-uppercase mb-0 roboto-black contact" },
	                  "Social"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { className: "list-inline font-xl-l" },
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-inline-item" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.facebook.com/gojektech ",
	                        target: "_blank"
	                      },
	                      _react2.default.createElement("i", {
	                        className: "fa fa-facebook-official text-green",
	                        "aria-hidden": "true"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-inline-item px-5" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://twitter.com/gojektech ",
	                        target: "_blank"
	                      },
	                      _react2.default.createElement("i", {
	                        className: "fa fa-twitter text-green",
	                        "aria-hidden": "true"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-inline-item" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://www.linkedin.com/company/gojektech/",
	                        target: "_blank"
	                      },
	                      _react2.default.createElement("i", {
	                        className: "fa fa-linkedin-square text-green",
	                        "aria-hidden": "true"
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-502f4018cda30a434d9f.js